import React, { CSSProperties } from 'react';
import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';

interface Props {
  iconStyle?: CSSProperties;
}

const UnassignedUserDisplay: React.FC<Props> = ({ iconStyle }) => {
  return (
    <UnassignedIconAndText>
      <UserIcon id="userIcon" icon="unassigned" height={18} style={iconStyle} />
      Unassigned
    </UnassignedIconAndText>
  );
};

export default UnassignedUserDisplay;

const UnassignedIconAndText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  opacity: 0.33;
`;

const UserIcon = styled(PolarisIcon)`
  margin-right: ${({ theme }) => theme.spacing(0.5)};
  line-height: 1px;
  opacity: 0.66;
  position: relative;
`;
